import { Button, DialogActions, DialogBody, DialogContent, DialogTitle } from "@fluentui/react-components"

interface DialogButtonProps {
    label: string;
    onClick: () => void;
    appearance?: 'primary' | 'secondary';
    disabled?: boolean;
}

export const renderDialog = ( title: string, content: React.ReactNode, buttons: DialogButtonProps[] ) => {
    return (
        <DialogBody>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{content}</DialogContent>
            <DialogActions>
                {buttons.map((button) => (
                    <Button key={button.label} onClick={button.onClick} appearance={button.appearance} disabled={button.disabled}>{button.label}</Button>
                ))}
            </DialogActions>
        </DialogBody>
    )
}